export const Regex = {
  RestrictSpecialChars: /[^A-Za-z0-9:;<=>?\^{}|~!'#$%&'()*+,.`_@\-\[\]\/\\ ]/g,
  AlphaNumericOnly: /^[a-zA-Z0-9 ]*$/,
  Password: /^(?=.*[0-9])(?=.*[a-z])(?=.*[A-Z])(?=.*[-!"#\$%\&'\(\)*+,./:;<=>\?@\[\]])(?=\S+$).{6,}$/,
  //Email: /.{1,}@.{1,}\..{1,}/,
  Email: /^[a-zA-Z0-9._+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z0-9]{2,20}$/,
  Phone: /[0-9]{10}/,
  CreditCard: {
    Visa: /^(?:4[0-9]{12}(?:[0-9]{3})?)$/,
    Master: /^(?:5[1-5][0-9]{2}|222[1-9]|22[3-9][0-9]|2[3-6][0-9]{2}|27[01][0-9]|2720)[0-9]{12}$/,
    AmericanExpress: /^(?:3[47][0-9]{13})$/,
    Discover: /^(?:6(?:011|5[0-9][0-9])[0-9]{12})$/
  },
  Date: /^(0[1-9]|1[0-2])\/(0[1-9]|1\d|2\d|3[01])\/\d{4}$/,
  WhiteSpace: /^[^-\s][a-zA-Z0-9_\s-]+$/,
  AllowSpecialChars:/^[^-\s][A-Za-z0-9\^%&()+,._\-\[\]\/\\ ]+$/,
};

export const AppMessages = {
  SessionExpiredTitle: 'Session Expired',
  GenericErrorMessage: 'An error has occured while processing your request.',
  OrderDeniedMessage: `Your current access is limited to payment, web account maintenance, and DSCSA transaction reports.
                    If you would like to enable your account for access to the entire parmed.com website,
                    please contact customer service at 800.727.6331 for assistance.`,
  MobileOrderDeniedMessage:
    'Your current access to ParMed functionality is limited. ' +
    'If you would like to enable your account for access to all ParMed functionality, ' +
    'please contact Customer Service at 800.727.6331 for assistance.',
  AssociationMessage: 
    'Your current access is limited to  web account maintenance. ' +
    'If you would like to enable your account for access to the entire parmed.com website, ' +
    'please contact customer service at 800.727.6331 for assistance.',
  MajorAssociationMessage: 
    'Your current access is limited to  web account maintenance. ' +
    'If you would like to enable your account for access to the entire major-rugby.com website, ' +
    'please contact customer service at 800.616.2471 for assistance.',
  MobileAssociationMessage:
    'Your current access is limited to  web account maintenance. ' +
    'If you would like to enable your account for access to the entire parmed.com website, ' +
    'please contact customer service at 800.727.6331 for assistance.',
  MajorMobileAssociationMessage:
    'Your current access is limited to  web account maintenance. ' +
    'If you would like to enable your account for access to the entire major-rugby.com website, ' +
    'please contact customer service at 800.616.2471 for assistance.',
    MajorOrderEnableMessage:
    'Your current access is limited to placing orders and web account maintenance.'+
    ' If you need additional access, please contact'+
    ' <a href="mailto:majorwebsupport@major-pharm.com">majorwebsupport@major-pharm.com </a>'+
    ' for assistance.',
    MajorPayInvoiceEnableMessage:
    'Your current access is limited to making payments and web account maintenance.'+
    ' If you need additional access, please contact'+
    ' <a href="mailto:majorwebsupport@major-pharm.com">majorwebsupport@major-pharm.com </a>'+
    ' for assistance.',
    MajorDscsaEnableMessage:
    'Your current access is limited to DSCSA transaction reports and web account maintenance.'+
    ' If you need additional access, please contact'+
    ' <a href="mailto:majorwebsupport@major-pharm.com">majorwebsupport@major-pharm.com </a>'+
    ' for assistance.',
    MajorOrderAndPayEnableMessage:
    'Your current access is limited to placing orders, making payments and web account maintenance.'+
    ' If you need additional access, please contact'+
    ' <a href="mailto:majorwebsupport@major-pharm.com">majorwebsupport@major-pharm.com </a>'+
    ' for assistance.',
    MajorOrderAndDscsaEnableMessage:
    'Your current access is limited to placing orders, DSCSA transaction reports and web account maintenance.'+
    ' If you need additional access, please contact'+
    ' <a href="mailto:majorwebsupport@major-pharm.com">majorwebsupport@major-pharm.com </a>'+
    ' for assistance.',
    MajorPayInvoiceAndDscsaEnableMessage:
    'Your current access is limited to making payments, DSCSA transaction reports and web account maintenance.'+
    ' If you need additional access, please contact'+
    ' <a href="mailto:majorwebsupport@major-pharm.com">majorwebsupport@major-pharm.com </a>'+
    ' for assistance.',
    MajorNoAccessMessage:
    'Your current access is limited to web account maintenance.'+
    ' If you need additional access, please contact'+
    ' <a href="mailto:majorwebsupport@major-pharm.com">majorwebsupport@major-pharm.com </a>'+
    ' for assistance.',
};

export const HttpStatusCode = {
  Timeout: -1,
  NoContent: 204,
  BadRequest: 400,
  NotFound: 404,
  PreconditionRequired: 428
};

export const ErrorConfig = {
  SysErrId: 'SYS100',
  BadRequestId: 'SYS400',
  NotFoundId: 'SYS404',
  PreconditionRequiredId: 'SYS428',
  TimeoutId: 'UI408'
};

export const ChatGroups = {
  CUSTOMER_CARE: 'PH_PARMED_CustomerCare_Chat_Z1_English',
  SALES: 'PH_PARMED_Sales_Chat_Z1_English',
  CSR: 'PH_PARMED_CSR_Chat_Z1_English',
  REP_INITIATED: 'PH_PARMED_SalesRepInitiated_Chat_Z1_English'
};
/***************Enum Constants***************/

export enum AppEnv {
  Production = 'production',
  QA = 'qa',
  Stage = 'stage',
  Dev = 'development',
  Local = 'local'
}

export enum RequestHeaders {
  ContentType = 'Content-Type',
  ApiKey = 'x-api-key',
  AccessToken = 'access-token',
  AgentType = 'agent-type',
  BUID = 'buId'
}

export enum ResponseHeaders {
  AccessToken = 'access-token',
  RefreshToken = 'refresh'
}

export enum UserDeviceConstant {
  Desktop = 'Desktop',
  Tablet = 'Tablet',
  Mobile = 'Mobile'
}

export enum CacheConstant {
  Term_Type = 'term-type',
  Is_Credit_Available = 'is-credit-available',
  Change_Account = 'change-account',
  Okta_Operation = 'user-operation',
  User_Auth_Detail = 'user-auth-details',
  Auth_Tokens = 'auth-tokens',
  Static_Data = 'static-data',
  Temp_Credit_Cards = 'temp-credit-cards',
  Order_Review = 'review-order',
  Order_Submit = 'submit-order',
  Payment_Method = 'payment-method',
  Search_Tracker = 'search-tracker',
  Invoice_Number = 'invoice-number',
  Order_Number = 'order-number',
  Order_History_Detail = 'order-history-detail',
  Okta_Session_Id = 'session-id',
  User_Id = 'user-id',
  Substitute_Data = 'substitute-data',
  Okta_Authenticated = 'okta-authenticated',
  Store_Location = 'store-location',
  Expired_Password = 'expired-password',
  Search_Route = 'search-route',
  Catalog_Data = 'catalog-data',
  Favourite_List_Data = 'favourite-List-data',
  App_Version = 'app-version',
  Env_Properties = 'env-properties',
  Promotion_Name = 'promotion-name',
  Promotion_Message = 'promotion-message',
  CallBackUrl = 'CallBackURL',
  Subscription_Category = 'subscription-category',
  Subscription_Data= 'Subscription-data',
  ShowPopup = 'Show-Popup',
  Pwd_Dtl = 'pwd-dtl',
  Show_Login_Popup = 'show-login-popup',
  Okta_User_Id = 'okta-user-id',
  SalePopUp = 'Sale-Popup'
}

export enum CacheDuration {
  Default = 60 * 60 * 2,
  OneMinute = 60 * 1,
  OneHour = 60 * 60 * 1,
  TwoHour = 60 * 60 * 2
}

export enum ErrorResponseMessageType {
  Toastr = 'TOASTER',
  Page = 'PAGE',
  Modal = 'MODAL'
}

export enum OktaOperationType {
  ForgotPassword = 'forgot-password',
  ResetPassword = 'reset-password',
  ResetPwd = 'reset_password',
  ActivateUser = 'activate-user',
  ActivateNonMigrateUser = 'activate-non-migrate-user',
  UnlockAccount = 'unlock-account'
}

export enum OktaOperationSource {
  ForgotPassword = 'FORGOT_PASSWORD',
  ResetPassword = 'PASSWORD_RESET',
  ResetPwd = 'RESET_PASSWORD',
  ActivateUser = 'WELCOME',
  ActivateNonMigrateUser = 'ACTIVATE_NON_MIGRATE_USER',
  UnlockAccount = 'UNLOCK_ACCOUNT',
  SecurityQuestion = 'SECURITY_QUESTION'
}

export enum OktaEvents {
  Session_Expired = 'session_terminated',
  Token_Validation_Error = 'token_validation_error',
  Token_Expired = 'token_expires',
  Logout = 'logout'
}

export enum CMSPages {
  Home = 'HOME',
  Login = 'LOGIN',
  Mobile_Home = 'MOBILE_HOME',
  Mobile_Login = 'MOBILE_LOGIN'
}

export enum CMSTemplateNames{
  Web_ProductCatalog = 'Web Product Catalog',
  Mobile_ProductCatalog='Mobile Product Catalog',
  Web_Help = 'Web Help',
  Mobile_Help = 'Mobile Help',
  Web_AmazonPage ='Web Amazon',
  Mobile_AmazonPage ='Mobile Amazon',
  Web_HomePage ='Web Home',
  Mobile_HomePage ='Mobile Home',
  Web_AboutUs = 'Web AboutUs',
  Mobile_AboutUs ='Mobile AboutUs',
  Web_News = 'Web News',
  Mobile_News ='Mobile News',
  Web_Footer = 'Web Footer',
  Mobile_Footer = 'Mobile Footer'
}
export enum BUID {
  ParMed = 1,
  Major = 2
}

export enum OktaErrorCodes {
  Auth_Failed = 'E0000004'
}

export enum UserProperty {
  UserDetailNumber = 'userDetailNum',
  OktaId = 'oktaUID',
  PromptForNewOrder = 'promptForNewOrder',
  DefaultShiptoNum = 'defaultShipToNumber',
  DefaultSoldToNum = 'defaultSoldToNumber',
  Accounts = 'accounts',
  UserCustomerRef = 'userCustomerXrefs',
  OktaRecoveryQuestions = 'oktaRecoveryQuestions',
  Identification = 'userName',
  HarvardFlg = 'harvardFlg',
  FirstName = 'firstName',
  LastName = 'lastName',
  EmailAddress = 'emailAddress',
  PhoneNum = 'phoneNum',
  BusinessName = 'businessName'
}

export enum AccountProperty {
  CanOrderFlag = 'canOrderFlg',
  CreditBlock = 'isBlockedByCredit',
  Name = 'name',
  PayerId = 'accountPayerNum',
  AccountSoldToNum = 'accountSoldToNum',
  AccountShipToNum = 'accountShipToNum',
  AccountNum = 'accountNum'
}

export enum AdobeAnalytics {
  Condition_String = 'DTMDC_Parmed'
}

export enum AnalyticsPagePrefix {
  PAGE_PREFIX = 'cah:parmed:'
}

export enum AnalyticsSectionNames {
  ACCOUNT_MAINTENANCE = 'account maintenance',
  CONTECT_US = 'contact us',
  CSOSHELP = 'csoshelp',
  DSCSA = 'dscsa',
  HISTORICAL_DATA = 'historical data',
  HOME = 'home',
  MAINTENANCE = 'maintenance',
  NEW_CUSTOMER = 'new customer',
  PAYMENTS = 'payments',
  PUBLIC = 'public',
  RETURN_CONFIRMATION = 'returnconfirmation',
  RETURNS = 'returns',
  SDS = 'sds',
  EMED_BINAX_NOW = 'emedbinaxNOW',
  SHOP = 'shop'
}

export const AnalyticsPageNames = {
  ACCOUNT_SETTINGS:
    AnalyticsPagePrefix.PAGE_PREFIX +
    AnalyticsSectionNames.ACCOUNT_MAINTENANCE +
    ':' +
    'account settings',
  CHANGE_ACCOUNT:
    AnalyticsPagePrefix.PAGE_PREFIX +
    AnalyticsSectionNames.ACCOUNT_MAINTENANCE +
    ':' +
    'change account',
  MY_ACCOUNT:
    AnalyticsPagePrefix.PAGE_PREFIX +
    AnalyticsSectionNames.ACCOUNT_MAINTENANCE +
    ':' +
    'my account',
  CONTACT_US:
    AnalyticsPagePrefix.PAGE_PREFIX +
    AnalyticsSectionNames.CONTECT_US +
    ':' +
    'contact us',
  CONTACT_US_THANKYOU:
    AnalyticsPagePrefix.PAGE_PREFIX +
    AnalyticsSectionNames.CONTECT_US +
    ':' +
    'contact us thank you',
  CSOS_HELP:
    AnalyticsPagePrefix.PAGE_PREFIX +
    AnalyticsSectionNames.CSOSHELP +
    ':' +
    'csos help',
  DSCSA:
    AnalyticsPagePrefix.PAGE_PREFIX +
    AnalyticsSectionNames.DSCSA +
    ':' +
    'dscsa',
  DSCSA_TR_DATA:
    AnalyticsPagePrefix.PAGE_PREFIX +
    AnalyticsSectionNames.DSCSA +
    ':' +
    'dscsa transaction data',
  DSCSA_SEARCH_DATA:
    AnalyticsPagePrefix.PAGE_PREFIX +
    AnalyticsSectionNames.DSCSA +
    ':' +
    'search dscsa data',
  ORDER_HISTORY:
    AnalyticsPagePrefix.PAGE_PREFIX +
    AnalyticsSectionNames.HISTORICAL_DATA +
    ':' +
    'order history',
  PRODUCT_HISTORY:
    AnalyticsPagePrefix.PAGE_PREFIX +
    AnalyticsSectionNames.HISTORICAL_DATA +
    ':' +
    'product history',
  CSOS_ORDER_HISTORY:
    AnalyticsPagePrefix.PAGE_PREFIX +
    AnalyticsSectionNames.HISTORICAL_DATA +
    ':' +
    'submitted csos orders',
  MY_HOME:
    AnalyticsPagePrefix.PAGE_PREFIX +
    AnalyticsSectionNames.HOME +
    ':' +
    'my homepage',
  MAINTENANCE:
    AnalyticsPagePrefix.PAGE_PREFIX +
    AnalyticsSectionNames.MAINTENANCE +
    ':' +
    'maintenance',
  ACTIVATE_ACCOUNT:
    AnalyticsPagePrefix.PAGE_PREFIX +
    AnalyticsSectionNames.NEW_CUSTOMER +
    ':' +
    'activate account',
  CUSTOMER_FORMS:
    AnalyticsPagePrefix.PAGE_PREFIX +
    AnalyticsSectionNames.NEW_CUSTOMER +
    ':' +
    'customer forms',
  REGISTER_ONLINE:
    AnalyticsPagePrefix.PAGE_PREFIX +
    AnalyticsSectionNames.NEW_CUSTOMER +
    ':' +
    'register online',
  CARD_MGT:
    AnalyticsPagePrefix.PAGE_PREFIX +
    AnalyticsSectionNames.PAYMENTS +
    ':' +
    'card management',
  CREDIT_CARD_PAYMENT:
    AnalyticsPagePrefix.PAGE_PREFIX +
    AnalyticsSectionNames.PAYMENTS +
    ':' +
    'credit card payment',
  PAYMENT_OPTIONS:
    AnalyticsPagePrefix.PAGE_PREFIX +
    AnalyticsSectionNames.PAYMENTS +
    ':' +
    'payment options',
  ABOUT_US:
    AnalyticsPagePrefix.PAGE_PREFIX +
    AnalyticsSectionNames.PUBLIC +
    ':' +
    'about us',
  EMPLOYMENT:
    AnalyticsPagePrefix.PAGE_PREFIX +
    AnalyticsSectionNames.PUBLIC +
    ':' +
    'employment',
  HELP:
    AnalyticsPagePrefix.PAGE_PREFIX +
    AnalyticsSectionNames.PUBLIC +
    ':' +
    'help',
  HOME:
    AnalyticsPagePrefix.PAGE_PREFIX +
    AnalyticsSectionNames.PUBLIC +
    ':' +
    'home page',
  LEGAL:
    AnalyticsPagePrefix.PAGE_PREFIX +
    AnalyticsSectionNames.PUBLIC +
    ':' +
    'legal',
  NEWS:
    AnalyticsPagePrefix.PAGE_PREFIX +
    AnalyticsSectionNames.PUBLIC +
    ':' +
    'news',
  PRIVACY:
    AnalyticsPagePrefix.PAGE_PREFIX +
    AnalyticsSectionNames.PUBLIC +
    ':' +
    'privacy',
  PRODUCT_SERVICES:
    AnalyticsPagePrefix.PAGE_PREFIX +
    AnalyticsSectionNames.PUBLIC +
    ':' +
    'products and services',
  RETURN_CONFIRMATION:
    AnalyticsPagePrefix.PAGE_PREFIX +
    AnalyticsSectionNames.RETURN_CONFIRMATION +
    ':' +
    'return confirmation',
  REQUEST_RETURN:
    AnalyticsPagePrefix.PAGE_PREFIX +
    AnalyticsSectionNames.RETURNS +
    ':' +
    'request a return',
  RETURNS_PRODUCT_DETAILS:
    AnalyticsPagePrefix.PAGE_PREFIX +
    AnalyticsSectionNames.RETURNS +
    ':' +
    'return products detail',
  RETURNS_STORE_LOCATIONS:
    AnalyticsPagePrefix.PAGE_PREFIX +
    AnalyticsSectionNames.RETURNS +
    ':' +
    'return store location',
  SDS:
    AnalyticsPagePrefix.PAGE_PREFIX + AnalyticsSectionNames.SDS + ':' + 'sds',
  EMED_BINAX_NOW:
    AnalyticsPagePrefix.PAGE_PREFIX + AnalyticsSectionNames.EMED_BINAX_NOW + ':' + 'emedbinaxNOW',
  ANTIBIOTICS:
    AnalyticsPagePrefix.PAGE_PREFIX +
    AnalyticsSectionNames.SHOP +
    ':' +
    'antibiotics',
  FREQUENTLY_DISPENSED:
    AnalyticsPagePrefix.PAGE_PREFIX +
    AnalyticsSectionNames.SHOP +
    ':' +
    'frequently dispensed products',
  FULL_CATALOGS:
    AnalyticsPagePrefix.PAGE_PREFIX +
    AnalyticsSectionNames.SHOP +
    ':' +
    'full catalog',
  ORAL:
    AnalyticsPagePrefix.PAGE_PREFIX +
    AnalyticsSectionNames.SHOP +
    ':' +
    'oral contraceptives',
  ORDER_SUMMARY:
    AnalyticsPagePrefix.PAGE_PREFIX +
    AnalyticsSectionNames.SHOP +
    ':' +
    'order summary',
  OTC_PRODUCTS:
    AnalyticsPagePrefix.PAGE_PREFIX +
    AnalyticsSectionNames.SHOP +
    ':' +
    'otc products',
  PREBOOK:
    AnalyticsPagePrefix.PAGE_PREFIX +
    AnalyticsSectionNames.SHOP +
    ':' +
    'prebook',
  PRODUCT_DETAILS:
    AnalyticsPagePrefix.PAGE_PREFIX +
    AnalyticsSectionNames.SHOP +
    ':' +
    'product details',
  QUICK_ORDER:
    AnalyticsPagePrefix.PAGE_PREFIX +
    AnalyticsSectionNames.SHOP +
    ':' +
    'quick order',
  RECENTLY_ORDERED:
    AnalyticsPagePrefix.PAGE_PREFIX +
    AnalyticsSectionNames.SHOP +
    ':' +
    'recently launched generics',
  SEARCH_RESULTS:
    AnalyticsPagePrefix.PAGE_PREFIX +
    AnalyticsSectionNames.SHOP +
    ':' +
    'search results',
  SHOP:
    AnalyticsPagePrefix.PAGE_PREFIX + AnalyticsSectionNames.SHOP + ':' + 'shop',
  CART:
    AnalyticsPagePrefix.PAGE_PREFIX +
    AnalyticsSectionNames.SHOP +
    ':' +
    'shopping cart list',
  SPECIALS:
    AnalyticsPagePrefix.PAGE_PREFIX +
    AnalyticsSectionNames.SHOP +
    ':' +
    'specials'
};

/***************Enum Constants***************/
